import React, { useEffect, useState } from 'react';
import { useMeetingBot } from 'Shared/utils/hooks/use-meeting-bot';
import { MeetingBot } from 'Shared/api/BotManagement.api';
import { WpText } from 'Wpds/components/text';
import { WpCard, WpCardBody } from 'Wpds/components/card';
import moment from 'moment';
// Styles
import './WorkspaceHistoryMeetingSummaries.scss';

const WorkspaceHistoryMeetingSummaries = () => {
  const { fetchMeetingSummaryHistory } = useMeetingBot();
  const [summaries, setSummaries] = useState<MeetingBot[]>([]);

  useEffect(() => {
    const fetchSummaries = async () => {
      const response = await fetchMeetingSummaryHistory();
      setSummaries(response.data.data);
    };

    fetchSummaries();
  }, [fetchMeetingSummaryHistory]);

  const baseClassName = 'WorkspaceHistoryMeetingSummaries';

  return (
    <div className={baseClassName}>
      <WpText variant="titleMd">Meeting Summaries</WpText>
      <ul className={`${baseClassName}__summaries-list`}>
        {summaries.map(summary => (
          <WpCard key={summary.id}>
            <WpCardBody>
              <WpText variant="bodySm" noMargin>
                {moment(summary.attributes.startedAt).format('MMMM Do YYYY, h:mm A')}
              </WpText>
              <WpText bold noMargin>
                General Summary
              </WpText>
              <WpText>{summary.attributes.meetingSummary?.data.general_summary ?? 'No summary available'}</WpText>

              <WpText bold noMargin>
                Decisions
              </WpText>
              <ul>
                {summary.attributes.meetingSummary?.data.decisions?.length > 0 ? (
                  summary.attributes.meetingSummary.data.decisions.map(decision => (
                    <li key={decision}>
                      <WpText tag="span">{decision}</WpText>
                    </li>
                  ))
                ) : (
                  <li>
                    <WpText tag="span">No decisions available</WpText>
                  </li>
                )}
              </ul>

              <WpText bold noMargin>
                Action Items
              </WpText>
              <ul>
                {summary.attributes.meetingSummary?.data.action_items?.length > 0 ? (
                  summary.attributes.meetingSummary.data.action_items.map(item => (
                    <li key={item}>
                      <WpText tag="span">{item}</WpText>
                    </li>
                  ))
                ) : (
                  <li>
                    <WpText tag="span">No action items available</WpText>
                  </li>
                )}
              </ul>

              <WpText bold noMargin>
                Key Takeaways
              </WpText>
              <ul>
                {summary.attributes.meetingSummary?.data.key_takeaways?.length > 0 ? (
                  summary.attributes.meetingSummary.data.key_takeaways.map(takeaway => (
                    <li key={takeaway}>
                      <WpText tag="span">{takeaway}</WpText>
                    </li>
                  ))
                ) : (
                  <li>
                    <WpText tag="span">No key takeaways available</WpText>
                  </li>
                )}
              </ul>
            </WpCardBody>
          </WpCard>
        ))}
      </ul>
    </div>
  );
};

export default WorkspaceHistoryMeetingSummaries;
